import {
    List, ListItem, ListItemIcon, ListItemText,
    Divider, Box,
    Typography
  } from '@mui/material';
  import {
    Logout as LogoutIcon,
    Dashboard as DashboardIcon,
  } from '@mui/icons-material';
  import PeopleIcon from '@mui/icons-material/People';
  import PasswordIcon from '@mui/icons-material/Password';
  import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
  import { Link, useNavigate } from 'react-router-dom'; // Added for navigation
  
  const menuItems = [
    {
      name: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard'  // Changed to match your route paths
    },
    {
      name: 'Salaries',
      icon: <CurrencyExchangeIcon/>,
      path: '/salary'  // Changed to match your route paths
    },
    {
        name: 'Employees',
        icon: <PeopleIcon />,
        path: '/employees'  // Changed to match your route paths
      },
    {
      name: 'Change Password',
      icon: <PasswordIcon />,
      path: '/change-password'   // Changed to match your route paths
    }
  ];
  
  export default function AppSidebar() {
    const navigate = useNavigate();
  
    const handleLogout = () => {
      sessionStorage.clear(); // Clear session storage
      navigate('/'); // Redirect to login after logout
    };
  
    return (
      <Box
        sx={{
          width: 240,
          flexShrink: 0,
          backgroundColor: '#00BFFF',
          color: 'white',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '16px',
            height: '64px',
            boxSizing: 'border-box'
          }}
        >
          <img
            src="/images/logo.png"
            alt="Company Logo"
            style={{
              height: 40,
              marginRight: '8px',
              filter: 'brightness(0) invert(1)'
            }}
          />
        </Box>
  
        <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
  
        <List>
          {/* Regular menu items with Link */}
          {menuItems.map((item) => (
            <ListItem
              button
              key={item.name}
              component={Link}  // Changed to Link component
              to={item.path}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                },
                // Highlight active route
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  '& .MuiListItemIcon-root': {
                    color: 'white',
                  },
                },
              }}
            >
              <ListItemIcon sx={{ color: 'white', minWidth: '40px' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                primaryTypographyProps={{ color: 'white' }}
              />
            </ListItem>
          ))}
  
          {/* Logout button with onClick */}
          <ListItem
            button
            onClick={handleLogout}
            key="logout"
            to={'/'}  // Redirect to login on logout
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
              }
            }}
          >
            <ListItemIcon sx={{ color: 'white', minWidth: '40px' }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText
              primary="Logout"
              primaryTypographyProps={{ color: 'white' }}
            />
          </ListItem>
        </List>
      </Box>
    );
  }